const map = {
	"./asset-after-sales-manage-active.svg": "./src/assets/images/menus/asset-after-sales-manage-active.svg",
	"./asset-after-sales-manage.svg": "./src/assets/images/menus/asset-after-sales-manage.svg",
	"./asset-launch-manage-active.svg": "./src/assets/images/menus/asset-launch-manage-active.svg",
	"./asset-launch-manage.svg": "./src/assets/images/menus/asset-launch-manage.svg",
	"./company-mange.svg": "./src/assets/images/menus/company-mange.svg",
	"./financial-manage-active.svg": "./src/assets/images/menus/financial-manage-active.svg",
	"./financial-manage.svg": "./src/assets/images/menus/financial-manage.svg",
	"./logs-active.svg": "./src/assets/images/menus/logs-active.svg",
	"./logs.svg": "./src/assets/images/menus/logs.svg",
	"./master-data-manage-active.svg": "./src/assets/images/menus/master-data-manage-active.svg",
	"./master-data-manage.svg": "./src/assets/images/menus/master-data-manage.svg",
	"./payment-tracking-active.svg": "./src/assets/images/menus/payment-tracking-active.svg",
	"./payment-tracking.svg": "./src/assets/images/menus/payment-tracking.svg",
	"./place-manage-active.svg": "./src/assets/images/menus/place-manage-active.svg",
	"./place-manage.svg": "./src/assets/images/menus/place-manage.svg",
	"./stocktaking-manage-active.svg": "./src/assets/images/menus/stocktaking-manage-active.svg",
	"./stocktaking-manage.svg": "./src/assets/images/menus/stocktaking-manage.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/menus sync recursive ^\\.\\/.*\\.svg$";